import ErrorBoundary from "@/components/ErrorBoundary";
import HeroSection from "@/Containers/Home/Components/hero-section";
import { memo, useEffect, useRef } from "react";
import Helmet from "react-helmet";
import CallToAction from "./Components/call-to-action";
import Faq4 from "./Components/faqs-4";
import Features12 from "./Components/features-12";

import { animate, stagger } from "motion";
import { splitText } from "motion-plus";
const LandingPage = () => {
  const containerRef = useRef(null);
  const featuresRef = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    document.fonts.ready.then(() => {
      if (!containerRef.current) return;

      // Hide the container until the fonts are loaded
      containerRef.current.style.visibility = "visible";

      const { words } = splitText(containerRef.current.querySelector("h1"));

      // Animate the words in the h1
      animate(
        words,
        { opacity: [0, 1], y: [10, 0] },
        {
          type: "spring",
          duration: 2,
          bounce: 0,
          delay: stagger(0.05),
        }
      );
    });
  }, []);
  return (
    <ErrorBoundary>
      <Helmet>
        <title>
          EASA Part-66 Exam Prep & Mock Tests | Pass Your Modules | Part-66
          Study iOS App
        </title>
        <meta
          name="description"
          content="Pass your EASA Part-66 exams with the ultimate study tool for iOS. Features a massive question bank updated for the 2025 syllabus, realistic mock tests, and performance analytics. The smartest way to get your Aircraft Maintenance License (AML). CAA / NAA / DGCA"
        />
        <link rel="canonical" href="https://part66.tabbythecat.com" />
      </Helmet>

      <HeroSection onScrollToFeatures={() => scrollToSection(featuresRef)} />
      <Features12 featuresRef={featuresRef} />
      <Faq4 />
      <CallToAction />
    </ErrorBoundary>
  );
};

export default memo(LandingPage);
